import { useState, useEffect } from "react";
import { Outlet, useSearchParams, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import useRefreshToken from '../hooks/useRefreshToken';
import useAuth from '../hooks/useAuth';
import URIs from "../utils/uri";
import {jwtDecode} from "jwt-decode";
import logo from "../assets/images/hashinLogoLight.png";
import { getUserProfile } from "../api/user/userApi";
import useProtectedClient from "../hooks/useProtectedClient";

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { auth, setAuth } = useAuth();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const protectedClient = useProtectedClient();

    const accessToken = searchParams.get('token');

    const verifyRefreshToken = async () => {
        try {
            await refresh();
        } catch (err) {
            console.error("Error refreshing token: ", err);
            navigate(URIs.LOGIN, { replace: true }); 
        } finally {
            setIsLoading(false);
        }
    };

    useEffect( () => {
        const checkAccess = async () => {
            try{
                if (accessToken) {
                    const decodedToken = jwtDecode(accessToken);
                    const roles = decodedToken.roles;
                    const data = await getUserProfile(protectedClient);
                    setAuth(prev => ({
                        ...prev,
                        roles,
                        accessToken,
                        profile: data.profile,
                        referCode: data.referCode,
                        walletBallance: data.walletBallance
                    }));
                    
                    setIsLoading(false); 
                } else if (!auth?.accessToken) {
                    verifyRefreshToken(); 
                } else {
                    
                    const decodedToken = jwtDecode(auth?.accessToken);
                    const roles = decodedToken.roles;
                    const data = await getUserProfile(protectedClient);
                    setAuth(prev => ({
                        ...prev,
                        roles: roles,
                        authStatus: data.authStatus,
                        profile: data.profile,
                        referCode: data.referCode,
                        walletBallance: data.walletBallance
                    }));
                    
                    setIsLoading(false); 
                }
            }catch(err){
                console.error("Invalid access token:", err);
                navigate(URIs.LOGIN, { replace: true });
            }
            
        }

        checkAccess();
    }, [accessToken, auth?.accessToken]);

    return (
        <>
            {isLoading ? (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100vh"
                    bgcolor="#f5f5f5" // Optional background color
                >
                    <img
                        src={logo} // Your logo file
                        alt="Loading Logo"
                        style={{ width: "150px", height: "auto" }} // Adjust logo size as needed
                    />
                </Box>
            ) : (
                <Outlet /> // Render child routes once loading is complete
            )}
        </>
    );
};

export default PersistLogin;
